import { formatErrorMessage, formatPrefixedToastError } from '../../shared/errorLogging';

export { formatErrorMessage as formatToastError, formatPrefixedToastError, formatErrorMessage };

/** Static or pre-formatted error toast (no err object). */
export function showToastErrorMessage(message: string): void {
  window.dispatchEvent(new CustomEvent('toast-error', { detail: message }));
}

/** Toast from a caught error / unknown value, including err.cause when present. */
export function showToastError(err: unknown, fallback = 'Unknown error'): void {
  showToastErrorMessage(formatErrorMessage(err, fallback));
}

/** Toast with a fixed prefix plus error details and cause. */
export function showPrefixedToastError(prefix: string, err: unknown, fallback = 'Unknown error'): void {
  showToastErrorMessage(formatPrefixedToastError(prefix, err, fallback));
}
